require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./les-programmes-doctoraux-2-3-4.json") })
        }
      }, "path---les-programmes-doctoraux-2-3-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---les-programmes-doctoraux-2-3-4!./.cache/json/les-programmes-doctoraux-2-3-4.json
// module id = 478
// module chunks = 231608221292675